import { Input, Directive, ViewChild, Output, EventEmitter, HostListener, ElementRef, AfterViewInit, OnDestroy } from '@angular/core';
import { BsDropdownDirective } from 'ngx-bootstrap/dropdown';
import { Subscription } from 'rxjs';

@Directive({
	selector: 'vb-base-menu',
	standalone: false
})
export class VbBaseMenuComponent implements AfterViewInit, OnDestroy {
	@Input() public translations: Record<string, string>;
	@Input() public isSmallSizePlayer: boolean;
	@Output() public menuCollapsed: EventEmitter<any> = new EventEmitter<any>();

	private timeoutRef: number;
	private focusedIndex: number;
	private bSubscription: Subscription;

	@ViewChild('dropdown')
	public dropdown: BsDropdownDirective;

	@ViewChild('vbDropdownMenu')
	public dropdownMenu: ElementRef;

	@HostListener('mouseleave', ['$event'])
	public onMouseLeave(_$event): void {
		if (!this.dropdown.isOpen) {
			return;
		}
		this.timeoutRef = window.setTimeout(() => {
			this.hideMenu(true);
		}, 3000);
	}

	@HostListener('mouseenter', ['$event'])
	public onMouseEnter(_$event): void {
		window.clearTimeout(this.timeoutRef);
		this.timeoutRef = null;
	}

	public ngAfterViewInit(): void {
		this.bSubscription = this.dropdown?.isOpenChange.subscribe(isOpened => {
			this.onMenuOpenChange(isOpened);
		});
	}

	public ngOnDestroy(): void {
		this.bSubscription?.unsubscribe();
	}

	public hideMenu(closeParent?: boolean): void {
		this.dropdown.hide();

		this.menuCollapsed.emit({ closeParent });
	}

	public toggleDropdown(): void {
		this.dropdown.toggle(true);
	}

	public onMenuOpenChange(isOpened: boolean): void {
		this.focusedIndex = 0;
		if (isOpened) {
			this.focusFirstMenuItem();
		}
	}


	public focusFirstMenuItem(): void {
		window.setTimeout(() => {
			this.dropdownMenu.nativeElement.focus();
		}, 200);
	}
}

//Combines class names from multiple sheets by concatenating them with a space.
export function mergeStyles<T1,T2>(a: T1, b: T2): T1 & T2;
export function mergeStyles(...styleSheets: any[]): any {
	const acc = {} as any;
	for(const styles of styleSheets) {
		for(const className of Object.keys(styles)) {
			const old = acc[className];
			const newStyle = styles[className];
			acc[className] = old ? old + ' ' + newStyle : newStyle;
		}
	}
	return acc;
}
